import { Product } from '../types';

export const getNewActiveResource = (active_resource: Product, unmapped_resources: Product[]) => {
  let new_active_resource: Product | undefined = active_resource;
  if (!active_resource?.instances?.length && unmapped_resources?.length) {
    const first = unmapped_resources[0];
    let second;
    if (unmapped_resources.length > 1) {
      second = unmapped_resources[1];
    }
    new_active_resource = first.product_id === active_resource?.product_id ? second : first;
  }
  return new_active_resource;
};
